import type { Config } from '../../_config'
import { FactoryCookie } from '../../_cookie/FactoryCookie'
import { DomainError } from '../../_kernel/DomainError'
import { ErrorsCode } from '../../_kernel/ErrorsCode'
import { ID } from '../../_kernel/ID'
import { ListOfID } from '../../_kernel/ListOfID'
import type { ListOfPaginatedID } from '../../_kernel/ListOfPaginatedID'
import type { LikeBelong } from '../domain/LikeBelong'
import type { ListOfProperty } from '../domain/ListOfProperty'
import type { ListOfTheme } from '../domain/ListOfTheme'
import type { PropertyRepository, saveLastSeenInput } from '../domain/PropertyRepository'

export class CookiePropertyRepository implements PropertyRepository {
  static create({ config }: { config: Config }) {
    return new CookiePropertyRepository(config)
  }

  constructor(private config: Config) {}

  async saveLastSeenIDs({ ids }: saveLastSeenInput): Promise<ListOfID> {
    const cookie = await FactoryCookie.create({ config: this.config }).cookie()
    const [error] = cookie.save({ key: 'vpid', value: ids.toString() })

    if (error) throw DomainError.withCodes(ErrorsCode.ERROR_SAVING_LIST_LAST_SEEN_PROPERTIES)

    return ids
  }

  async lastSeenIDs(): Promise<ListOfID> {
    const cookie = await FactoryCookie.create({ config: this.config }).cookie()
    const [error, ids] = cookie.get({ key: 'vpid' })

    if (error) return ListOfID.empty()
    if (!ids) return ListOfID.empty()

    const list = ids.split(',').map(id => ID.create({ value: id }))
    return ListOfID.create({ list })
  }

  async findByIDs(): Promise<ListOfProperty> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async findByBannerID(): Promise<ListOfProperty> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async relatedByID(): Promise<ListOfProperty> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async saveLike(): Promise<ID> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async deleteLike(): Promise<ID> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async isLiked(): Promise<LikeBelong> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async getUserLikesIds(): Promise<ListOfPaginatedID> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async getThemes(): Promise<ListOfTheme> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }
}
